import { get, remove, postJSON } from "api/base";
//@ts-ignore: importing json
import JSONVideoCategories from "json/socialvideocategories.min.json";

const TWITTER_CREDENTIAL_ENDPOINT = `v1/integration/twitter`;
const TWITTER_MONETIZATION_ENDPOINT = `${TWITTER_CREDENTIAL_ENDPOINT}/monetization`;

export async function getCategories(socialId: string) {
    try {
        const response = await get(
            `${TWITTER_MONETIZATION_ENDPOINT}/user-social-credential/${socialId}/categories`
        );
        const {
            data: {
                data: { categories }
            }
        } = response;
        return categories;
    } catch (e) {
        console.error(`Failed to get X (Twitter) In-Stream Ads categories`, e);
        return JSONVideoCategories.twitter.categories;
    }
}

export async function getAdvertiserCategories(socialId: string) {
    try {
        const response = await get(
            `${TWITTER_MONETIZATION_ENDPOINT}/user-social-credential/${socialId}/categories`
        );
        const {
            data: {
                data: { advertiserCategories }
            }
        } = response;
        return advertiserCategories;
    } catch (e) {
        console.error(
            `Failed to get Twitter In-Stream Ads advertiser categories`,
            e
        );
        return JSONVideoCategories.twitter.advertiser_categories;
    }
}

export const deleteMonetizationTemplate = (templateId: string) => {
    const endpoint = `${TWITTER_MONETIZATION_ENDPOINT}/instreamads/template/${templateId}`;
    return remove(endpoint);
};

export const createNewMonetizationTemplate = (data, options = {}) => {
    const endpoint = `${TWITTER_MONETIZATION_ENDPOINT}/instreamads/template`;
    return postJSON(endpoint, data, options);
};

export const getMonetizationTemplates = (socialId: string, options = {}) => {
    const endpoint = `${TWITTER_MONETIZATION_ENDPOINT}/user-social-credential/${socialId}/instreamads/template`;
    return get(endpoint, options);
};

export type TwitterAdAccounts = {
    name: string;
    id: string;
    approvalStatus: string;
};

/**
 * @summary - Returns a list of the available ad accounts to share with twitter cards
 */
export const getTwitterAdAccounts = async (
    socialId: string
): Promise<TwitterAdAccounts[]> => {
    try {
        const response = await get(
            `${TWITTER_CREDENTIAL_ENDPOINT}/user-social-credential/${socialId}/ad-accounts`
        );
        const {
            data: { data }
        } = response;
        return data;
    } catch (e) {
        console.error(`Failed to get X (Twitter) Ad accounts`, e);
    }
};

export async function getTwitterUsers(query: string) {
    try {
        const response = await get(`/ws/tools/twitter/users/search?q=${query}`);
        return response;
    } catch (e) {
        console.error(`Failed to fetch X (Twitter) Users`, e);
    }
}

export async function getSponsorshipPrograms(socialId: string) {
    try {
        const response = await get(
            `/ws/tools/twitter/monetization/sponsorships/${socialId}`
        );
        return response;
    } catch (e) {
        console.error(`Failed to fetch X (Twitter) Sponsorship Programs`, e);
    }
}
